const recoveryTypeList = [
    {
        label: 'SMS',
        value: 'sms'
    },
    {
        label: 'Voice Call',
        value: 'call',
    }
]

export default recoveryTypeList
